import React, { useContext, useEffect } from 'react';
import PropTypes from "prop-types";
import withRouter from "../../components/Common/withRouter";

// import Components
import Sidebar from './Sidebar';
import Header from './Header';
// import Footer from './Footer';

//redux
import { useSelector, useDispatch } from "react-redux";

import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth
} from "../../store/actions";
import TopBarInside from '../../components/Common/TopBarInside';
import Breadcrumb from '../../components/Common/Breadcrumb';
import { fnGetValueByKey } from '../../helpers/functions';
import { AuthProtectedContext } from '../../Routes/AuthProtectedContext';

const Layout = props => {
  const dispatch = useDispatch();

  const { transactionData } = useContext(AuthProtectedContext);

  const {
    layoutWidth,
    leftSideBarType,
    topbarTheme,
    leftSideBarTheme,
    topbarInside,
    isModalPage,
    isIframePage
  } = useSelector(state => ({
    leftSideBarType: state.Layout.leftSideBarType,
    layoutWidth: state.Layout.layoutWidth,
    topbarTheme: state.Layout.topbarTheme,
    leftSideBarTheme: state.Layout.leftSideBarTheme,
    topbarInside: state.Layout.topbarInside,
    isModalPage: state.Layout.isModalPage,
    isIframePage: state.Layout.isIframePage
  }));

  
  const breadcrumb = () => {
    let value = fnGetValueByKey(transactionData, "BREAD_CRUMB")
    try {
      return JSON.parse(value)
    } catch (error) {
      console.warn("Breadcrumbs: não mapeado pelo backend");
      return [value]
    }
  }

  const transactionCode = fnGetValueByKey(transactionData, "CODIGO_TRANSACAO")
  const transactionCodeDescribe = fnGetValueByKey(transactionData, "DESCRICAO_TRANSACAO")

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile));
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile));
    }
  };

  useEffect(() => {
    dispatch(changeLayout("vertical"));
  }, [dispatch]);

  useEffect(() => {
    if (leftSideBarTheme) {
      dispatch(changeSidebarTheme(leftSideBarTheme));
    }
  }, [leftSideBarTheme, dispatch]);

  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth));
    }
  }, [layoutWidth, dispatch]);

  useEffect(() => {
    if (leftSideBarType) {
      dispatch(changeSidebarType(leftSideBarType));
    }
  }, [leftSideBarType, dispatch]);

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme));
    }
  }, [topbarTheme, dispatch]);

  return (
    <React.Fragment>
      <div id="layout-wrapper" className={(isModalPage || isIframePage ? "modal-page-view" : "")}>
        {!isModalPage && !isIframePage && 
        <>
          <Header toggleMenuCallback={toggleMenuCallback} />
          <Sidebar
            theme={leftSideBarTheme}
            type={leftSideBarType}
            isMobile={isMobile}
          />
        </>
        }
        <div className="main-content" style={{...(isModalPage || isIframePage ? {padding: 0, margin: 0, backgroundColor: "white"} : {})}}>
          {!isModalPage && !isIframePage && topbarInside?.isActive == 'S' && topbarInside?.payload?.length > 0 && <TopBarInside />}
          {!isModalPage && <Breadcrumb items={breadcrumb()} transactionCode={transactionCode} transactionDescribe={transactionCodeDescribe} />}
          {props.children}
        </div>
        {/* {!isModalPage && <Footer /> } */}
      </div>
    </React.Fragment>
  );
};


Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.object,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  topbarTheme: PropTypes.any,
  changeIsModalPage: PropTypes.func
};

export default withRouter(Layout);
